import { Component } from '@angular/core';
@Component({
    selector: 'cva-standalone-landing-page',
    standalone: true,
    imports: [],
    templateUrl: './landing-page.component.html'
})
export class LandingPageComponent {
}
